// Because webpack assets run on a separate port, we need to set a publicPath.
// However we need to set it at runtime, in case we're accessing it via an IP
// address rather than 'localhost'.
// See https://github.com/webpack/webpack/issues/443#issuecomment-53896311
if (window.resourceBaseUrl) {
  // eslint-disable-next-line
  __webpack_public_path__ = window.resourceBaseUrl;
}
